const setRoles = (_root, { roles }, { cache }) => {
  cache.writeData({ data: { roles } })
  return null
}

export default setRoles
